<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs12>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>

          </v-btn>
        </v-flex>

        <v-flex xs12 md1 class="mb-2">
          <v-btn
            fab
            small
            @click="printTable()"
            class="ml-8 white--text"
            color="#2b6993"
            elevation="4"
            absolute
            right
          >
            <v-icon>print</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12>
          <h3 class="text-center mb-5">Attendance Report</h3>
          <v-divider class="ml-4 mr-4 mb-3"></v-divider>

        </v-flex>

        <v-flex xs12>
          <v-card
            class="ma-3 pa-3"
            elevation="0"
          >
            <v-layout row wrap>
              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  ref="calendarMenu"
                  v-model="calendarMenu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.startDate"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules='requiredField'
                      clearable
                      @change="getAttendance()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.startDate"
                    no-title
                    scrollable
                    :rules='requiredField'

                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="calendarMenu = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.calendarMenu.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

              </v-flex>

              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  ref="calendar2Menu"
                  v-model="calendar2Menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules='requiredField'
                      clearable
                      @change="getAttendance()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.endDate"
                    no-title
                    scrollable
                    :rules='requiredField'
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="calendar2Menu = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.calendar2Menu.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Client Status"
                  :items="clientStatuses"
                  v-model="filters.clientStatus"
                  clearable
                  @change="getAttendance"
                ></v-select>
              </v-flex>

              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Select a Client"
                  :items="filteredClients"
                  item-text="Name"
                  item-value="._id"
                  v-model="filters.ClientID"
                  clearable
                  @change="getAttendance()"
                ></v-select>

              </v-flex>

              <!-- <v-flex xs12 md2 class="pa-1 mb-2">
                  <v-select
                      label="Select a Service Code"
                      :items="serviceCodes"
                      v-model="ServiceCode"
                      :disabled="isServiceCodeDisabled"
                      clearable
                      @change="getAttendance()"
                  ></v-select>
              </v-flex> -->

              <v-flex xs12 md1 class="mt-5 mb-5 pl-5">
                <v-btn
                  small
                  @click="getAttendance()"
                  :loading="searchBtnLoader"
                  :disabled="searchBtnLoader"
                >
                  Search
                </v-btn>
              </v-flex>

              <v-flex xs12 md1 class="mt-5 mb-5 pl-5">
                <v-btn small @click="downloadAttendance()" class="ml-2">Download</v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>


        <v-flex xs12 class="pa-2">
          <v-data-table
            :headers="headers"
            :items="attendance"
            sort-by="Date"
            sort-desc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Attendance"
          >
            <template v-slot:item.ClientId="{ item }">
              <ul>
                <li v-for="(client, i) in item.ClientId" :key="i">{{ client.Name }}</li>
              </ul>
            </template>
            <!-- <template v-slot:item.select="{ item }">

                <v-btn
                    x-small
                    class="white--text"
                    color="#2b3990"
                    @click="viewAttendance(item)"
                >
                    view
                </v-btn>

            </template> -->
          </v-data-table>

          <v-dialog
            v-model="dialog"
            max-width="100%"
            persistent
          >
            <v-card>
              <v-card-title style="background-color: #2b3990">
                <span class="headline white--text">{{ titleForm }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form
                    ref="form"
                    lazy-validation
                  >
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          label="Service Code"
                          v-model="newCode"
                          :rules="requiredRules"
                          readonly
                        >

                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="newUnits"
                          label="Units"
                          readonly
                          disabled
                          :rules="requiredRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" v-if="requiredTime">
                        <v-menu
                          ref="startTimeMenu"
                          v-model="showStartTimePicker"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="timeStart"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="timeStart"
                              label="Time Start"
                              prepend-icon="mdi-clock-time-four-outline"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="showStartTimePicker"
                            v-model="timeStart"
                            full-width
                            @change="setTimeStart(timeStart)"
                            format="ampm"
                            ampm-in-title
                            readonly
                          ></v-time-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" sm="12" md="6" v-if="requiredTime">
                        <v-menu
                          ref="endTimeMenu"
                          v-model="showEndTimePicker"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="timeEnd"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="timeEnd"
                              label="Time End"
                              format="ampm"
                              prepend-icon="mdi-clock-time-four-outline"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="showEndTimePicker"
                            v-model="timeEnd"
                            full-width
                            @change="setTimeEnd(timeEnd)"
                            format="ampm"
                            ampm-in-title
                            readonly
                          ></v-time-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <!-- <v-text-field
                          v-model="newDate"
                          label="Date(YYYY-MM-DD)"
                          placeholder="YYYY-MM-DD"
                          :rules="requiredRules"
                          v-mask="maskDate"
                        ></v-text-field> -->


                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="newDate"
                              label="Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newDate"
                            no-title
                            scrollable
                            readonly
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col class="d-flex" cols="12" sm="12" md="6">
                        <v-checkbox
                          @click="addSignature()"
                          label="Signature"
                          v-model="checkSignature"
                        ></v-checkbox>
                        <v-text-field v-if="signed == true" v-model="newSignature"
                                      readonly></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn class="white--text" color="#259647" @click="addAttendance()" v-if="newAttendance">Save</v-btn>
                <v-btn color="blue darken-1" text @click="updateAttendance()" v-if="editAttendance">Update</v-btn> -->
                <v-btn color="blue darken-1" text @click="close">close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-flex>
      </v-layout>
    </v-card>
    <div id="print">
      <report-header>
        <h2>Attendance Report</h2>
      </report-header>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="attendance"
            sort-by="Date"
            sort-desc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Attendance"
            :items-per-page="-1"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import ReportHeader from '@/components/Report/ReportHeader.vue';
import {STATUS_ARRAY} from '../../enums/UserStatusEnum';
import {DateTime} from "luxon";

const url = require("../../client_config/config").url;

export default {
  components: {
    ReportHeader
  },
  data: () => ({
    headers: [
      {text: 'Service Date', align: 'start', value: 'ClockInSchedule', sortable: true},
      {text: 'Start Time', value: 'FormattedClockIn'},
      {text: 'End Time', value: 'FormattedClockOut'},
      {text: "Client", value: "ClientId"},
      {text: "Service Code", value: "ServiceCode"},
      {text: "Service Unit", value: "serviceUnit"},
      {text: "Units", value: "totalUnits"},
      {text: "Service Provided By", value: "Employee.Name"},
      {text: "", value: "select"},
      // { text: "Actions", value: "actions", sortable: false }
    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    // page: 'Incidents',
    clients: [],
    clientIds: [],
    serviceCodes: [],
    attendance: [],
    ServiceCode: '',
    calendarMenu: false,
    calendar2Menu: false,
    report: '',
    clientName: '',
    isLoading: false,
    requiredField: [
      v => !!v || 'This is required',
    ],
    isServiceCodeDisabled: false,
    userState: localStorage.getItem('userState'),
    dialog: false,
    editAttendance: false,
    newAttendance: false,
    msg: false,
    snackbarColor: "black",
    search: "",
    text: "",
    codes: [],
    users: [],
    userID: localStorage.getItem('userID'),
    staff: localStorage.getItem('Name'),
    tempData: [],
    titleForm: "New Attendance Record",
    attendanceID: "",
    newName: "",
    newCode: "",
    newDate: "",
    newSignature: "",
    Rate: "",
    signed: false,
    checkSignature: false,
    newUnits: "",
    newServiceUnit: "",
    requiredRules: [
      v => !!v || 'This is required',
    ],
    timeStartPicker: false,
    timeStart: null,
    timeEndPicker: false,
    timeEnd: null,
    timeEndAdjust: null,
    requiredTime: false,
    newServiceCodeDialog: false,
    newServiceCodeAdd: "",
    maskDate: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
    maskTimeStart: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
    maskTimeEnd: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
    showStartTimePicker: false,
    showEndTimePicker: false,
    timeStartDisplay: '',
    timeEndDisplay: '',
    menu: false,
    clientState: "",
    page: 1,
    pageCount: 1,
    itemCount: 0,
    options: {},
    clientStatuses: STATUS_ARRAY,
    searchBtnLoader: false,
    filters: {
      startDate: '',
      endDate: '',
      clientStatus: '',
      ClientID: ''
    }
  }),

  computed: {
    filteredClients() {
      let clients = this.clients;

      if (this?.filters.clientStatus != "" && this.filters.clientStatus) {
        clients = clients.filter((client) => client.Status == this.filters.clientStatus)
      }

      return clients;
    },
  },

  watch: {
    options: {
      handler() {
        this.getAttendance();
      },
      deep: true
    },

    filters: {
      handler() {
        this.setFilters();
      },
      deep: true
    }
  },

  created() {
    this.getClients();
    this.getServiceCodesFromCode();
    this.getFilters();
    this.getAttendance();
  },

  methods: {
    initialize() {
      this.clients = [];
      this.serviceCodes = [];
    },

    getClients() {
      this.state = this.userState || '';

      axios.get(`${url}/clients/state/${this.state}`).then(async res => {
        this.clients = res.data.clients || [];
        this.clientIds = this.clients.map(client => client._id);
        await this.getAttendance();
        this.clients.unshift({
          _id: 'All',
          Name: 'All Clients'
        });
      });
    },
    getServiceCodesFromCode() {
      axios.get(`${url}/codes/list`).then(async res => {
        this.serviceCodes = res.data;
      });
    },

    getClientState() {
      axios.get(`${url}/clients/${this.ClientID}`).then(res => {
        this.clientState = res.data.client.State;
      })
    },

    async getAttendance() {
      this.searchBtnLoader = true;
      let startDate;
      let endDate;

      let today = DateTime.now();
      let lastMonth = DateTime.now().minus({months:1});

      let defaultEndDate = today.toFormat('yyyy-MM-dd');
      let defaultStartDate = lastMonth.toFormat('yyyy-MM-dd');

      if (this.filters.startDate) {
        startDate = new Date(this.filters.startDate);
        startDate.setHours(0, 0, 0);
        startDate.toISOString()
      } else {
        startDate = new Date(defaultStartDate);
        startDate.setHours(0, 0, 0);
        startDate.toISOString()
      }

      if (this.filters.endDate) {
        endDate = new Date(this.filters.endDate);
        endDate.setHours(23, 59, 59);
        endDate.toISOString()
      } else {
        endDate = new Date(defaultEndDate);
        endDate.setHours(23, 59, 59);
        endDate.toISOString()
      }

      try {
        let params = {
          startDate: startDate,
          endDate: endDate,
          state: this.userState
        };

        if (this.filters.ClientID) {
          params.ClientID = this.filters.ClientID;
        }

        if (this.filters.clientStatus) {
          params.clientStatus = this.filters.clientStatus;
        }

        const response = await axios.get(`${url}/timesheets/report/attendance`, {params});
        this.attendance = response.data;
      } catch (err) {
        this.error = err.message;
        console.error(err);
      } finally {
        this.searchBtnLoader = false;
      }
    },

    downloadAttendance() {
      const validationMessage = this.validateAttendanceDownload();

      if (validationMessage) {
        alert(`Failed to download attendance. ${validationMessage}`);
        return;
      }

      window.location.href = `${url}/attendance/download?defaultClientIds=${this.clientIds.toString()}&clientId=${this.ClientID}&serviceCode=${this.ServiceCode}&startDate=${this.startDate}&endDate=${this.endDate}`;
    },

    validateAttendanceDownload() {
      if (!this.startDate) {
        return 'Start date is required.';
      }

      if (!this.endDate) {
        return 'End date is required.';
      }

      if (!this.ClientID) {
        return 'Client is required.';
      }

      // if (!this.clientIds) {
      //     return 'Client ids is required.';
      // }
      //
      // if (!this.ServiceCode) {
      //     return 'Service code is required.';
      // }

      return '';
    },

    getClientID(item) {
      this.client = item.ClientID;
      window.localStorage.setItem('clientId', this.client)
      console.log(this.client)
    },
    initializeServiceCode() {
      if (this.ClientID === 'All') {
        this.isServiceCodeDisabled = true;
        this.ServiceCode = '';
      } else {
        const matchedClient = this.clients.find(client => client._id === this.ClientID);

        if (matchedClient) {
          this.serviceCodes = matchedClient.ServiceCode;
        }
      }
    },
    viewAttendance(item) {
      this.dialog = true;
      this.titleForm = "Viewing Attendance"
      this.$store.commit("attendance/SET_ADD_ATTENDANCE_DIALOG", true);
      this.editAttendance = true;
      this.newAttendance = false;
      this.requiredTime = false;
      this.newName = item.Name;
      this.newCode = item.Code;
      this.newDate = item.Date
      if (item.ServiceUnit === "Quarter Hour" || item.ServiceUnit === "Session" || item.ServiceUnit === "Hourly") {
        this.requiredTime = true;
        this.timeStart = item.TimeStart;
        this.timeEnd = item.TimeEnd;
      }

      if (item.Signature != "") {
        this.newSignature = item.Signature;
        this.signed = true;
        this.checkSignature = true;
      }
      this.newUnits = item.Units;
      this.newServiceUnit = item.ServiceUnit;
      this.attendanceID = item._id;
    },

    updateAttendance() {
      var req_body = {
        Name: this.newName,
        Code: this.newCode,
        Date: this.newDate,
        Signature: this.newSignature,
        Units: this.newUnits,
        ServiceUnit: this.newServiceUnit,
        TimeStart: this.timeStart,
        TimeEnd: this.timeEnd,
        Rate: this.Rate,
      };
      axios.put(`${url}/attendance/${this.attendanceID}`, req_body).then((response) => {
        this.getAttendance();
        if (response.status == 400) {
          response.json().then(function (data) {
            alert(data.msg);
          });
        }
        this.msg = true;
        this.text = "The attendance record has been updated successfully.";
      });
      this.close();
    },

    printTable() {
      window.print()

    },

    close() {
      this.dialog = false;
      this.requiredTime = false;
      this.resetForm();
    },
    resetForm() {
      this.newName = "";
      this.newCode = "";
      this.newDate = "";
      this.newSignature = "";
      this.newUnits = "";
      this.newServiceUnit = "";
      this.signed = false;
      this.timeStart = null;
      this.timeEnd = null;
    },
    getFilters() {
      let filters = localStorage.getItem('clientAttendanceReportFilter');
      if (filters) {
        this.filters = JSON.parse(filters);
      }
    },

    setFilters() {
      localStorage.setItem('clientAttendanceReportFilter', JSON.stringify(this.filters));
    }
  }
}
</script>
<style>
#print {
  display: none
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }

  body {
    margin: 1.6cm;
  }
}
</style>
